<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div class="row">
            <div class="col-md-10 col-sm-12" >
                <h4 class="atlhr-dashboard-title mt-10">Employee Management<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Employee Management</span></h4>
            </div>
        </div>


        <div class="card mt-0 border-0 no-shadow reports-tab-nav mt-5">

            <div class="card-header px-0 bg-transparent border-0">

                <div class="row trz-selected-employees-count">
                    <div class="col-md-10 col-sm-12" v-if="selected.length == 1">
                        <span>Selected No of Employee: </span><span >{{selected.length}}</span>
                    </div>
                    <div class="col-md-10 col-sm-12" v-if="selected.length > 1">
                        <span>Selected No of Employees: </span><span >{{selected.length}}</span>
                    </div>
                </div>
                <div class="row no-margin">
                    <div class="col-sm-10 pl-0" > <!-- Mustafijur Changed: col-sm-9 to col-sm-10 on 09-04-2026 -->
                        <div class="employee-btn-holder trz_ppl_wrapper_2"> <!-- Mustafijur Added: trz_ppl_wrapper_2 on 09-04-2026 -->
                            <b-dropdown class="trz-custom-dropdown mb-1">
                                <!-- Mustafijur Starts: on 09-04-2026 -->
                                <template #button-content>
                                    <b-icon icon="upload" class="mr-2"></b-icon> Import
                                </template>
                                <!-- Mustafijur Ends: on 09-04-2026 -->
                                <b-dropdown-group id="dropdown-group-1" header="Employee">
                                    <b-dropdown-item :href="$api_url+'/employee/import'" v-if="this.$acl['employee/import'] > 1">Add multiple employees</b-dropdown-item>
                                    <b-dropdown-item :href="$api_url+'/employee/import-for-update'" v-if="this.$acl['employee/import'] == 2" >Update multiple employees</b-dropdown-item>
                                    <b-dropdown-item :href="$api_url+'/employee/import-employee-email-phone'" v-if="this.$acl['employee/import'] == 2" >Bulk Update Email/Phone Number</b-dropdown-item>
                                </b-dropdown-group>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Contracts">
                                    <b-dropdown-item :href="$api_url+'/contract/import/new'" v-if="this.$acl['contract/import'] > 1">Add contracts</b-dropdown-item>
                                    <b-dropdown-item :href="$api_url+'/contract/import'" v-if="this.$acl['contract/import'] > 1">Update multiple contracts</b-dropdown-item>
                                </b-dropdown-group>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Bulk Import">
                                    <b-dropdown-item :href="$api_url+'/employee/import/data/investment'" v-if="this.$acl['employee/investment_import'] > 1">Investment</b-dropdown-item>
                                    <b-dropdown-item :href="$api_url+'/employee/import/data/ait'" v-if="this.$acl['employee/ait_import'] > 1">AIT</b-dropdown-item>
                                    <b-dropdown-item :href="$api_url+'/employee/import/data/bankinfo'" v-if="this.$acl['employee/import'] > 1">Bank Account</b-dropdown-item>
                                    <!-- Start: Import Payment Bank Information: Rejwan: 26-01-2025 -->
                                    <b-dropdown-item :href="$api_url+'/employee/import-bank-payment'" v-if="this.$acl['employee/import'] > 1">Payment Bank Information</b-dropdown-item>
                                    <!-- End: Import Payment Bank Information: Rejwan: 26-01-2025 -->

                                    <!-- Start: Import Personal Tax Filing: Sohel -->
                                    <b-dropdown-item :href="$api_url+'/employee/import-ptf-bulk-data'" v-if="this.$acl['employee/import'] > 1">Personal Tax Return Filing Acknowledgement</b-dropdown-item>
                                    <!-- End: Import Personal Tax Filing: Sohel -->

                                    <!-- Start: Import Personal Tax Filing: Sohel -->
                                    <b-dropdown-item :href="$api_url+'/employee/import-ptf-bulk'" v-if="this.$acl['employee/import'] > 1">Personal Tax Return Filing Acknowledgement (PDF)</b-dropdown-item>
                                    <!-- End: Import Personal Tax Filing: Sohel -->

                                    <!-- Sohel: New mappings update -->
                                    <b-dropdown-item :href="$api_url+'/employee/import-cost-center-bulk'" v-if="this.$acl['employee/import'] > 1">Add/Update Cost Center</b-dropdown-item>
                                    <!-- Sohel: New mappings update -->

                                    <b-dropdown-item @click="importServiceBook" v-if="this.$acl && this.$acl['admin-service-book/import-export'] == 2">Service Book</b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Migrated Data" v-if="this.$acl['employee/import'] > 1">
                                    <b-dropdown-item :href="$api_url+'/employee/import/data/migrated-payroll'" v-if="this.$acl['employee/mph'] > 1">Payroll History for selected employees</b-dropdown-item>
                                    <b-dropdown-item :href="$api_url+'/employee/import/data/migrated-pf'" v-if="this.$acl['employee/mpfh'] > 1">PF History for selected employees</b-dropdown-item>
                                </b-dropdown-group>

                            </b-dropdown>

                            <b-dropdown class="trz-custom-dropdown mb-1"> <!-- Mustafijur Removed:  text="Export" on 12-04-2026 -->
                                <!-- Mustafijur Starts: on 12-04-2026 -->
                                <template #button-content>
                                    <b-icon icon="download" class="mr-2"></b-icon> Export
                                </template>
                                <!-- Mustafijur Ends: on 12-04-2026 -->
                                <b-dropdown-group id="dropdown-group-1" header="Employee" v-if="this.$acl['employee/export'] > 1">
                                    <b-dropdown-item @click="exportSelected" >Export employee info </b-dropdown-item>
                                    <b-dropdown-item @click="exportUpdate(0)" >Export employee data for update</b-dropdown-item>
                                    <b-dropdown-item @click="exportUpdate(6)" >Export employee Email and Phone</b-dropdown-item>
                                    <!-- Start: Export Payment Bank Information: Rejwan: 26-01-2025 -->
                                    <b-dropdown-item @click="exportSelectedEmployeeBankPaymentInfo" >Export employee bank payment info</b-dropdown-item>
                                    <!-- Start: Export Payment Bank Information: Rejwan: 26-01-2025 -->
                                </b-dropdown-group>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Contracts">
                                    <b-dropdown-item @click="exportContract" v-if="this.$acl['contract/export'] > 1">Export all contracts</b-dropdown-item>
                                    <b-dropdown-item @click="exportContractSelected" v-if="this.$acl['contract/export'] > 1">Export seletced contract(s)</b-dropdown-item>
                                </b-dropdown-group>
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Bulk Export">
                                    <b-dropdown-item @click="exportUpdate(1)" v-if="this.$acl['employee/investment_import'] > 1">Investment for selected employees</b-dropdown-item>
                                    <b-dropdown-item @click="exportUpdate(2)" v-if="this.$acl['employee/ait_import'] > 1">AIT for selected employees</b-dropdown-item>
                                     <b-dropdown-item @click="exportUpdate(3)" v-if="this.$acl['employee/export'] > 1">Bank Account for selected employees</b-dropdown-item>
                                </b-dropdown-group>

                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Migrated Data">
                                    <b-dropdown-item @click="exportUpdate(4)" v-if="this.$acl['employee/mph'] > 1">Payroll History for selected employees</b-dropdown-item>
                                    <b-dropdown-item @click="exportUpdate(5)" v-if="this.$acl['employee/mpfh'] > 1">PF History for selected employees</b-dropdown-item>
                                </b-dropdown-group>                                             
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Service Book — Bulk Import/Export" v-if="this.$acl['admin-service-book/import-export'] == 2">
                                    <b-dropdown-item @click="downloadServiceBookTemplate">Export Service Book Data for Update</b-dropdown-item>
                                </b-dropdown-group>                    
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-group id="dropdown-group-1" header="Service Book" v-if="this.$acl['admin-service-book/import-export'] == 2">
                                    <b-dropdown-item @click="exportServiceBook('both', 'flat')">Export Both (Bangla + English)</b-dropdown-item>
                                    <b-dropdown-item @click="exportServiceBook('bn', 'flat')">Export Bangla</b-dropdown-item>
                                    <b-dropdown-item @click="exportServiceBook('en', 'flat')">Export English</b-dropdown-item>
                                </b-dropdown-group>
                                <b-dropdown-group id="dropdown-group-1" header="Service Book — Booklet" v-if="this.$acl['admin-service-book/import-export'] == 2">
                                    <b-dropdown-item @click="exportServiceBook('bn', 'booklet')">Export Booklet – Bangla</b-dropdown-item>
                                    <b-dropdown-item @click="exportServiceBook('en', 'booklet')">Export Booklet – English</b-dropdown-item>
                                </b-dropdown-group>
                            </b-dropdown>

                            <b-dropdown text="Request Document" class="trz-custom-dropdown mb-1">
                                <b-dropdown-group id="dropdown-group-99">
                                    <b-dropdown-item @click="requestDocuments('personal-documents')" >Personal Documents</b-dropdown-item>
                                    <b-dropdown-item @click="requestDocuments('tax-documents')" >Tax Documents</b-dropdown-item>
                                    <b-dropdown-item @click="requestDocuments('personal-tax-return-filing-ack')" >Personal Tax Return Filing Acknowledgement</b-dropdown-item>
                                    <b-dropdown-item @click="requestDocuments('other-documents')" >Other Documents</b-dropdown-item>
                                </b-dropdown-group>
                            </b-dropdown>


                            <b-button  class="mb-1 btn-primary custom-wizard-btn" @click="massUpdate" v-if="this.$acl['employee/bulk'] == 2">Bulk Changes</b-button> <!-- Mustafijur: 13-05-2026 removed btn-white and added btn-primary custom-wizard-btn -->
                            <b-button  class="mb-1 btn-primary custom-wizard-btn" @click="massApproverAssign" v-if="modules.length > 0">Assign Approvers</b-button> <!-- Mustafijur: 13-05-2026 btn-primary custom-wizard-btn -->
                            <b-button  class="mb-1 btn-primary custom-wizard-btn" :href="$api_url+'/custom/attribute'" v-if="this.$acl['custom/attribute'] > 0">Custom Fields</b-button> <!-- Mustafijur Added: class btn-white on 12-04-2026 -->
                            <id-card-generate-button :employee_ids="selected" v-if="this.$acl['id-card'] == 2"></id-card-generate-button>

                            <!-- Start: Download Personal Tax Filing Bulk: Sohel -->
                            <b-button  class="mb-1 btn-primary custom-wizard-btn" @click="showDownloadModal">Download Personal Tax Return Filing Acknowledgement (PDF)</b-button> <!-- Mustafijur: 13-05-2026 btn-primary custom-wizard-btn -->
                            <!-- End: Download Personal Tax Filing Bulk: Sohel -->

                            <!-- Start: Investment & AIT Bulk: Afrin -->
                            <b-dropdown text="Manage Investment/AIT" class="trz-custom-dropdown mb-1" v-if="is_investment_enabled || is_ait_enabled">
                                <b-dropdown-group id="dropdown-group-1">
                                    <b-dropdown-item :href="$api_url + '/employee/pendinginvestment'" v-if="is_investment_enabled">Investment</b-dropdown-item>
                                    <b-dropdown-item :href="$api_url + '/employee/pendingait'" v-if="is_ait_enabled">Advance Income Tax</b-dropdown-item>
                                </b-dropdown-group>
                            </b-dropdown>
                            <!-- End: Investment & AIT Bulk: Afrin -->

                        </div>
                    </div>
                    <div class="col-sm-2 pr-0" v-if="this.$acl['employee/add'] > 1"> <!-- Mustafijur Changed: col-sm-3 to col-sm-2 on 12-04-2026 -->
                        <div class="col-12 text-right pr-0" :class="{ 'employee-list-view': !viewmode }"><b-button  class="mb-1" :href="$api_url+'/employee/add'" style="max-width: 325px;"><b-icon icon="person-plus-fill" class="mr-2"></b-icon>Add Employee</b-button></div> <!-- Mustafijur Added: b-icon and removed class w-100 on 12-04-2026 -->
                    </div>
                </div>
            </div>

            <div v-if="emailing != ''" class="alert alert-info" role="alert"><img :src="this.$api_url+'/images/loading.gif'" width="20" class="mr-2"> We are initiating email sending process. Please wait, this may take few seconds... </div>
            <div v-if="emailing_success != ''" class="alert alert-success" role="alert"><b-icon icon="check-circle-fill" class="mr-2" variant="success"></b-icon> {{emailing_success}} </div>


            <common-list class="Employee-view-table" :email_class='this.emailing_class' :employee_draft=1 :checkbox="checkbox" :is_action="is_action" :key="list_key" :appended_column="appended_column" :company_options="company_options" :employees="employees" :default_column="default_column" :primary_key="primary_key" :switch_view="1" :all_employee="all_employee" edit_icon="yes" v-on:childToParent="listReturn"></common-list>

            <b-modal id="bv-modal-massApproverAssign" hide-footer title="Mass Approver Assign">
                <approver-approvers @event="closeModal" :employee_ids="selected"></approver-approvers>
            </b-modal>

            <b-modal id="bv-modal-massupdate" hide-footer title="Bulk Changes">
                <b-form @submit.stop.prevent="onSubmitMassUpdate">

                    <!-- <template v-if="cost_centers.length > 1">
                        <b-form-group id="cost_center_id-group" label="Cost Center" label-for="cost_center_id">
                            <b-form-select id="cost_center_id" name="cost_center_id" v-model="fdata.cost_center_id" :options="cost_centers" ></b-form-select>
                        </b-form-group>
                    </template> -->

                    <!-- <b-form-group id="department-group" label="Department" label-for="department_id">
                        <select name="department_id" class='custom-select' v-model='fdata.department_id'>
                            <option value='0' >Select Department</option>
                            <option v-for='data in departments' :value='data.id'>{{ data.name }}</option>
                        </select>
                    </b-form-group>


                    <b-form-group id="jobposition-group" label="Job Position" label-for="jobposition_id">
                        <select name="jobposition_id" class='custom-select' v-model='fdata.jobposition_id'>
                            <option value='0' >Select Jobposition</option>
                            <option v-for='data in jobpositions' :value='data.id'>{{ data.name }}</option>
                        </select>
                    </b-form-group>


                    <b-form-group id="branch_id-group" label="Work Location" label-for="branch_id">
                        <select name="branch_id" class='custom-select' v-model='fdata.branch_id'>
                            <option value='0' >Select Work Location</option>
                            <option v-for='data in branches' :value='data.id'>{{ data.name }}</option>
                        </select>
                    </b-form-group>


                    <b-form-group id="leave_policy_id-group" label="Leave Policy" label-for="leave_policy_id">
                        <b-form-select id="leave_policy_id" name="leave_policy_id" v-model="fdata.leave_policy_id" :options="leave_policies" ></b-form-select>
                    </b-form-group> -->

                    <b-form-group id="manager_id-group" label="Reporting Manager" label-for="manager_id">
                        <b-form-select id="manager_id" name="manager_id" v-model="fdata.manager_id" :options="manager" ></b-form-select>
                    </b-form-group>


                    <!--<b-form-group id="gender-group" label="Gender" label-for="gender">
                        <b-form-select id="gender" name="gender" v-model="fdata.gender" :options="departments" ></b-form-select>
                    </b-form-group>
                     <b-form-group id="marital_status-group" label="Marital Status" label-for="marital_status">
                        <b-form-select id="marital_status" name="marital_status" v-model="fdata.marital_status" :options="marital_status" ></b-form-select>
                    </b-form-group> -->

                    <b-button type="submit" variant="primary">Submit</b-button>
                </b-form>

            </b-modal>

            <b-modal id="bv-modal-request_docement" hide-footer title="Request Document" v-if="this.selected.length > 0">
                <request-docements :employee_ids="this.selected" :request_document_type="this.request_document_type" v-on:childToParent="sendRequestDocumentMail"></request-docements>
            </b-modal>

            <b-modal id="bv-modal-personal-tax-filing" hide-footer title="Download Personal Tax Files (PDF)">
                <b-form @submit.prevent="submitFormPtfp">
                    <!-- Select Fiscal Year -->
                    <b-form-group
                        label="Select Fiscal Year"
                        label-for="fiscal-year"
                        class="mb-3 d-block required-field"
                    >
                        <b-col cols="6" class="px-0">
                            <b-form-select
                                id="fiscal-year"
                                name="fiscal_year"
                                v-model="fiscal_year"
                                :options="payrunyears"
                                :state="validateState('fiscal_year')"
                                v-validate="{ required: true }"
                                data-vv-as="Fiscal Year"
                                aria-describedby="fiscal-year-feedback"
                                class="custom-select"
                            ></b-form-select>
                            <b-form-invalid-feedback id="fiscal-year-feedback">
                                {{ veeErrors.first('fiscal_year') }}
                            </b-form-invalid-feedback>
                        </b-col>
                    </b-form-group>

                    <b-button type="submit" variant="primary" class="mt-3">
                        Download
                    </b-button>
                </b-form>
            </b-modal>

        </div>

    </b-overlay>
</template>


<script>
export default{

        data(){


            return {

                ce:false,

                /**Child Component property data */
                checkbox:1,
                is_action:0,
                list_key:0,
                employees : [],
                default_column:['name','employee_code','phone','email','jobposition','department','employee_type','branch'],
                primary_key:'employee_id',
                company_options:[],
                appended_column:[],
                /***Child Component property data */
                selected: [],
                showoverlay : true,
                viewmode :true,
                notice: "Looks like you have not added any employee yet.",
                fdata: {
                            residency:null ,
                            gender:null ,
                            marital_status:null ,
                            department_id:0 ,
                            employee_type_id:0,
                            jobposition_id:0,
                            branch_id:0,
                            manager_id:0,
                            leave_policy_id:0,
                            cost_center_id:0,
                        },

                residency: [
                    { value: null, text: "Select..." },
                    { value: "Resident", text: "Resident" },
                    { value: "Non Resident", text: "Non Resident" }
                ],
                gender:[
                    { value: null, text: "Select..." },
                    { value: "Male", text: "Male" },
                    { value: "Female", text: "Female" },
                    { value: "Other", text: "Other" },
                ],
                marital_status:[
                    { value: null, text: "Select..." },
                    { value: "Single", text: "Single" },
                    { value: "Married", text: "Married" },
                    { value: "Widower", text: "Widower" },
                    { value: "Divorced", text: "Divorced" },
                ],
                branches:[],
                departments:[],
                jobpositions:[],
                manager:[],
                cost_centers:[],
                leave_policies : [],
                company_name : '',
                all_employee: 'yes',
                emailing_success : "",
                emailing : '',
                emailing_class : '',

                request_document_type : '',

                payrunyears: [],
                fiscal_year: '',

                modules : [],

                // approver settings
                is_investment_enabled: false,
                is_ait_enabled: false,
                // approver settings
            }
        },
        methods:{

            getApproverModuleSettings(){
                Promise.all([
                    axios.get(this.$api_url + '/approver/settings/1'),
                    axios.get(this.$api_url + '/approver/settings/2'),
                    axios.get(this.$api_url + '/approver/settings/3'),
                ]).then(([mod1, mod2, mod3]) => {
                    if (mod1.data['status'] == 1) {
                        this.modules.push({ value: 1, text: 'Leave' });
                    }

                    if (mod2.data['status'] == 1) {
                        this.modules.push({ value: 2, text: 'Mobility Attendance' });
                    }

                    if (mod3.data['status'] == 1) {
                        this.modules.push({ value: 3, text: 'Attendance Adjustment' });
                    }
                });
            },

            closeModal(){
                this.list_key++;
                this.$bvModal.hide('bv-modal-massApproverAssign');
            },
            massApproverAssign: function()
            {
                if(this.selected == '')
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                    this.$bvModal.show('bv-modal-massApproverAssign');

                }
            },

            requestDocuments : function(type)
            {
                if(this.selected == '')
                    this.$bvToast.toast("No employee selected", {title: 'Warning!',variant: 'warning',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                    this.request_document_type = type;
                    this.$bvModal.show('bv-modal-request_docement');
                }

            },
            sendRequestDocumentMail : function()
            {
                this.emailing_class = 'trz_email';
                this.list_key = this.list_key + 1;
                this.emailing='1';

                    setTimeout(() => {
                        this.emailing='';
                        this.emailing_success='Email sending initiated. Receiver(s) should receive email soon. Please advise receivers to check spam / junk folder too if they complain about the emails are not being received.';

                }, 5000);
            },

            getEmployees: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                axios.get(this.$api_url+'/employee/list' , {

                    }).then(function(response){

                        this.showoverlay = false;
                        if(response.data.error == 1)
                            this.notice = response.data.notice;
                        else
                        {
                            this.employees = response.data.employee_data;
                            this.company_options = response.data.options;
                            this.list_key = this.list_key + 1;

                        }

                        }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            listReturn:function(data)
            {
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];
                    if(data.employee_id > 0)
                    {
                        this.editEmployee(data.employee_id,0);
                    }

                }
            },
            getBranches: function(){
              axios.get(this.$api_url+'/branch/list')
              .then(function (response) {
                 this.branches = response.data;
              }.bind(this));

            },
            getDepartments: function(){
              axios.get(this.$api_url+'/department/list')
              .then(function (response) {
                 this.departments = response.data;
              }.bind(this));

            },

            getJobpositions: function(){
              axios.get(this.$api_url+'/jobposition/list')
              .then(function (response) {
                 this.jobpositions = response.data;
              }.bind(this));

            },

            getLeavePolicies: function(){
              axios.get(this.$api_url+'/leave/policy/list')
              .then(function (response) {
                    this.leave_policies = [{ value: 0, text: "Select Leave Policy" } ] . concat(response.data);
              }.bind(this));

            },

            getManagers: function(){
              axios.get(this.$api_url+'/manager')
              .then(function (response) {
                    this.manager = [{ value: 0, text: "Select..." } ] . concat(response.data);
              }.bind(this));

            },
            getCostCenters: function(){
              axios.get(this.$api_url+'/get_all_cost_center')
              .then(function (response) {
                    this.cost_centers = [{ value: 0, text: "Select..." } ] . concat(response.data);
              }.bind(this));

            },
            editEmployee:function(x , i)
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/employee/setemployee', formData)
                    .then(function (response)
                    {
                        this.showoverlay = false;
                        if(i == 6)
                            window.location.href = this.$api_url+'/attendances';
                        else if(i > 0)
                            window.location.href = this.$api_url+'/employee/info?#=' + i;
                        else
                            window.location.href = this.$api_url+'/employee/info';

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },
            massUpdate: function()
            {
                if(this.selected == '')
                this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                    //alert(this.selected);
                    this.$bvModal.show('bv-modal-massupdate');

                }

            },
            resetForm()
            {
                this.fdata =  {
                            residency:null ,
                            gender:null ,
                            marital_status:null ,
                            department_id:0 ,
                            jobposition_id:0,
                            branch_id:0,
                            manager_id:0,
                            leave_policy_id:0,
                            cost_center_id:0,
                        };
            },
            onSubmitMassUpdate(e)
            {
                if(!this.checkNet()) return false;

                if((this.fdata.department_id > 0) && (this.fdata.jobposition_id == 0))
                {
                    //alert('Select Job Position for changed Department');
                    this.$bvToast.toast("Select Job Position for changed Department", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                }
                else
                {

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        if((value != null) && (value != 0))
                        {
                            var nm = `${key}`;
                            var fval = `${value}`;
                            formData.append(nm, fval);

                            //console.log(`${key}: ${value}`);
                        }
                    }

                    formData.append('employee_ids', this.selected);

                    axios.post(this.$api_url+'/employee/mass-update', formData, config)
                                .then(function (response)
                                {
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                    this.$bvModal.hide('bv-modal-massupdate');

                                    //this.employees = response.data.employees;
                                    //this.list_key = this.list_key++;
                                    this.getEmployees();

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                });
                }

            },
            exportSelected: function()
            {
                if(!this.checkNet()) return false;

                if(this.selected == '')
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                    let currentObj = this;
                    this.$bvToast.toast('It might take a while', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });
                    this.showoverlay = true;
                    let formData = new FormData();
                    console.log(this.selected);
                    formData.append('employee_ids', this.selected);
                    axios.post(this.$api_url+'/employee/export', formData)
                        .then(function (response)
                        {
                            this.showoverlay = false;
                            //window.open(response.data);
                            var fileURL = response.data;
                            // this.download_file(fileURL);
                            this.downloadFileContent(fileURL);

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                        });
                }

            },
            exportAll: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                this.$bvToast.toast('It might take a while', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });
                this.showoverlay = true;
                axios.get(this.$api_url+'/employee/export')
                    .then(function (response) {
                        this.showoverlay = false;
                        //window.open(response.data);
                        var fileURL = response.data;
                        // this.download_file(fileURL);
                        this.downloadFileContent(fileURL);
                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },
            exportUpdate: function(flg)
            {
                if(!this.checkNet()) return false;

                if(this.selected == '')
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                    let currentObj = this;
                    this.$bvToast.toast('It might take a while', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });
                    this.showoverlay = true;
                    let formData = new FormData();
                    formData.append('employee_ids', this.selected);
                    formData.append('flg', flg);
                    formData.append('forupdate', 1);

                    axios.post(this.$api_url+'/employee/export-for-update', formData)
                        .then(function (response)
                        {
                            this.showoverlay = false;
                            //window.open(response.data);
                            var fileURL = response.data;

                            // this.download_file(fileURL);
                            this.downloadFileContent(fileURL);

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                        });
                }

            },
            importServiceBook: function()
            {
                window.location.href = this.$api_url + '/admin-service-book/import-export';
            },
            exportServiceBook: function(lang, format)
            {
                if(this.selected == '' || this.selected.length == 0)
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                    let currentObj = this;
                    this.$bvToast.toast('It might take a while', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });
                    this.showoverlay = true;
                    let formData = new FormData();
                    formData.append('employee_ids', this.selected);
                    formData.append('lang', lang);
                    formData.append('format', format);

                    const config = {
                      headers: { 'Content-Type': 'application/json; charset=utf-8', },
                      responseType: 'blob',
                    }

                    axios.post(this.$api_url+'/admin-service-book/export-bulk', formData, config)
                        .then(function (response)
                        {
                            this.showoverlay = false;
                            if(response.data.type =='application/json'){
                                let file = new Blob([response.data], {type: 'application/json'});
                                const cast = Promise.resolve(file.text());
                                cast.then((value) => {
                                  let err_obj = JSON.parse(`${value}`);
                                  this.$bvToast.toast(err_obj.error_msg || err_obj.error, {title: 'Error',variant: 'danger',solid: true});
                                });
                             }else{
                                this.global_download_file_content(response);
                             }

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                        });
                }
            },
            downloadServiceBookTemplate: function()
            {
                if(this.selected == '' || this.selected.length == 0)
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                    let currentObj = this;
                    this.showoverlay = true;
                    let formData = new FormData();
                    formData.append('employee_ids', this.selected.join(','));

                    axios.post(this.$api_url + '/admin-service-book/import-export/download-template', formData, { responseType: 'blob' })
                        .then(function (response)
                        {
                            this.showoverlay = false;
                            if(response.data.type == 'application/json'){
                                let file = new Blob([response.data], {type: 'application/json'});
                                const cast = Promise.resolve(file.text());
                                cast.then((value) => {
                                  let err_obj = JSON.parse(`${value}`);
                                  this.$bvToast.toast(err_obj.error_msg || err_obj.error, {title: 'Error',variant: 'danger',solid: true});
                                });
                             }else{
                                this.global_download_file_content(response);
                             }
                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                        });
                }
            },
           exportContractSelected: function()
            {
                if(this.selected == '')
                this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                  this.exportContract('selected');
                }

            },
            exportContract: function(sltd='')
            {

                    this.$bvToast.toast('It might take a while', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });
                    this.showoverlay = true;
                    let formData = new FormData();
                    if(sltd.length>0 && this.selected)
                    formData.append('employee_ids', this.selected);

                    const config = {
                      headers: { 'Content-Type': 'application/json; charset=utf-8', },
                      responseType: 'blob',
                    }

                    axios.post(this.$api_url+'/contract/export', formData, config)
                        .then(function (response)
                        {
                            this.showoverlay = false;
                            if(response.data.type =='application/json'){
                                let file = new Blob([response.data], {type: 'application/json'}); /* if you use different error message just change the name instead of  'error_msg' */
                                const cast = Promise.resolve(file.text());
                                cast.then((value) => {
                                  let err_obj = JSON.parse(`${value}`);
                                  this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                                });
                             }else{
                                this.global_download_file_content(response);
                             }

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.errormsg = error.response.data.errors;
                        });


            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },

            getCompanyPublicData: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/details' , {
                    params: {

                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.company_id =  response.data.id;
                    this.company_name = response.data.name;

                }.bind(this));
            },

            // Start: Export Employees Bank payment Information: Rejwan: 26-01-2025
            exportSelectedEmployeeBankPaymentInfo: function()
            {
                if (this.selected == '') {
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                } else {
                    this.$bvToast.toast('It might take a while', {
                        title: `Info`,
                        variant: 'info',
                        solid: true
                    });
                    this.showoverlay = true;
                    let formData = new FormData();

                    if(this.selected.length>0)
                        formData.append('employee_ids', this.selected);

                    const config = {
                        headers: { 'Content-Type': 'application/json; charset=utf-8', },
                        responseType: 'blob',
                    }
                    axios.post(this.$api_url+'/employee/export-bank-payment', formData, config)
                        .then(function (response) {
                            this.showoverlay = false;

                            if(response.data.type =='application/json'){
                                let file = new Blob([response.data], {type: 'application/json'}); /* if you use different error message just change the name instead of  'error_msg' */
                                const cast = Promise.resolve(file.text());
                                cast.then((value) => {
                                  let err_obj = JSON.parse(`${value}`);
                                  this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                                });
                             }else{
                                this.global_download_file_content(response);
                             }
                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay = false;
                            currentObj.serverError(error);
                        });
                }
            },
            // End: Export Employees Bank payment Information: Rejwan: 26-01-2025

            showDownloadModal: function()
            {
                if(!this.checkNet()) return false;

                this.getpayrunyears();
                this.$bvModal.show('bv-modal-personal-tax-filing');
            },

            getpayrunyears: function () {
                axios.get('/get/fiscalyear/list').then(function (response) {
                this.payrunyears = response.data;

                }.bind(this));
            },

            submitFormPtfp: function()
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay = true;
                    const config = {
                        headers: { 'Content-Type': 'application/json; charset=utf-8', },
                        responseType: 'blob',
                    }

                    const formData = new FormData();
                    formData.append("fiscal_year", this.fiscal_year);

                    axios.post(this.$api_url + '/download-tax-files-bulk', formData, config)
                    .then(function (response) {
                        if(response.data){
                            if(response.data.type =='application/json'){
                                let file = new Blob([response.data], {type: 'application/json'});
                                const cast = Promise.resolve(file.text());
                                cast.then((value) => {
                                    let err_obj = JSON.parse(`${value}`);
                                    this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                                });
                            }else{
                                this.global_download_file_content(response);
                            }
                        }else if(response.data.error){
                            this.$bvToast.toast(response.data.error, {
                                title: 'Error!',
                                variant: 'danger',
                                solid: true
                            });
                        }
                        this.showoverlay = false;
                        // this.resetForm();
                        this.$bvModal.hide('bv-modal-personal-tax-filing'); // Mustafijur: 13-05-2026

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);

                        if (error.response && error.response.data && error.response.data.errors) {
                            currentObj.errormsg = error.response.data.errors;
                        } else if (error.message) {
                            currentObj.errormsg = { general: [error.message] };
                        } else {
                            currentObj.errormsg = { general: ['Unexpected error occurred.'] };
                        }
                    });
                });
            },

            // approver settings
            get_tax_reducers_settings: function(){
                axios.get('/get/taxreducers/settings').then(function (response) {
                if(response.data.investments && response.data.investments == 1){
                    this.is_investment_enabled = true;
                }else{
                    this.is_investment_enabled = false;
                }

                if(response.data.advance_income_tax && response.data.advance_income_tax == 1){
                    this.is_ait_enabled = true;
                }else{
                    this.is_ait_enabled = false;
                }

                }.bind(this));
            },
            // approver settings
        },
        created: function(){

            // this.getBranches();
            // this.getDepartments();
            this.getManagers();
            this.getCostCenters();
            //this.getLeavePolicies();
            this.getEmployees();
            // this.getJobpositions();
            this.getCompanyPublicData();
            this.get_tax_reducers_settings(); // approver settings


            this.getApproverModuleSettings();

            $(window).on('load', function (e) {
                setTimeout(function(){
                    $('.div1').width($('table.employee-list-table').width());
                    $('.div2').width($('table.employee-list-table').width());
                    if($('table.employee-list-table').width() > $('.wrapper1').width()){
                        //alert($('table.employee-list-table').width());
                        $('.wrapper1').show();
                    }else{
                        //alert('Its not bigger');
                        $('.wrapper1').hide();
                    }
                }, 2000);
                $('.wrapper1').on('scroll', function (e) {
                    $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
                });
                $('.wrapper2').on('scroll', function (e) {
                    $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
                });

                $(document).on("click",".trz-custom-dropdown .custom-switch input",function() {
                    setTimeout(function(){
                        $('.div1').width($('table.employee-list-table').width());
                        $('.div2').width($('table.employee-list-table').width());
                        if($('table.employee-list-table').width() > $('.wrapper1').width()){
                            $('.wrapper1').show();
                        }else{
                            $('.wrapper1').hide();
                        }
                    }, 500);
                });
            });
        }
    }
</script>
<style>
button.disabled{
    cursor: default;
}
.table-head td{
    cursor: pointer;
}
.table-head label{
    cursor: pointer;
}
.row.trz-selected-employees-count {
	position: absolute;
	top: -25px;
	width: 100%;
}
</style>
